//  拿急救车经纬度  || 以及病例的 目标地址
/*
 * 遍历所有的急救车列表
 * 急救车id对应上话, 取得急救车的经纬度, 并且展示在地图上
 * 再去这里去到患者的所有列表(因为是所有的,所以反正再去拿会更快一点)
 * 患者的id跟急救车绑定的患者id对应的话, 这里的急救车地址就是目的地地址
 * */
export function getSCoordinate(ambulanceLists, carID) {
  const car = ambulanceLists.find(e => {
    return e.id === carID * 1;
  });
  if (!car) return;
  const { longitude, latitude } = car;
  const targetLocation = "广州市珠江医院";
  let currentCarPoint;
  if (longitude && latitude) {
    currentCarPoint = [longitude, latitude];
  } else {
    currentCarPoint = [];
  }
  return {
    targetLocation,
    currentCarPoint
  };
}
